// @flow
import React, { PureComponent, type ComponentType } from "react";
import { getDisplayName } from "data/constants";
import loc from "i18next";

type Props = {
    /** callback when value has been changed
     * @param {string} name field's name
     * @param {any} value new field's value
     */
    onChange: (name: string, value: any) => void,
    /** current value */
    value: ?Array<any>,
};

type State = {
    value1: ?any,
    value2: ?any,
};

/** wraps *EditorControls to allow FromTo operator */
const toBetweenEditor = (
    WrappedComponent1: ComponentType<any>,
    WrappedComponent2: ComponentType<any>
) =>
    class PP extends PureComponent<Props, State> {
        upstreamOnChange: (name: string, value: any) => void;
        // opRef: ElementRef<*>;

        static displayName = `toBetweenEditor(${getDisplayName(
            WrappedComponent1
        )},${getDisplayName(WrappedComponent2)})`;

        constructor(props: Props) {
            super(props);
            this.state = {
                value1:
                    props.value && Array.isArray(props.value) && props.value[0],
                value2:
                    props.value && Array.isArray(props.value) && props.value[1],
            };
            this.upstreamOnChange = this.props.onChange;
        }

        _onChange = () => {
            this.upstreamOnChange(this.props.name, [
                this.state.value1,
                this.state.value2,
            ]);
        };

        _onChangeValue1 = (name: string, value1: any) =>
            this.setState({ value1 }, this._onChange);

        _onChangeValue2 = (name: string, value2: any) =>
            this.setState({ value2 }, this._onChange);

        render = () => (
            <WrappedComponent1
                {...this.props}
                value={this.state.value1}
                isRequired={false}
                onChange={this._onChangeValue1}
                placeholder={loc.t("search:form.input.placeholderFrom")}
                additionalRender={
                    <WrappedComponent2
                        {...this.props}
                        value={this.state.value2}
                        isRequired={false}
                        isAdditionalRender={true}
                        onChange={this._onChangeValue2}
                        placeholder={loc.t("search:form.input.placeholderTo")}
                    />
                }
            />
        );
    };

export default toBetweenEditor;
